import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 16BECBE7-BD8E-4301-B5CB-5EE534FBDAD3
 * name checkbox-multiple-marked-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-marked-outline.svg
 * tags
 * - Form 
 */
export const CheckboxMultipleMarkedOutlineIcon = createSvgIcon(<><path d="M20,16V10H22V16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z" /></>, 'CheckboxMultipleMarkedOutlineIcon');
export default CheckboxMultipleMarkedOutlineIcon